import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import {backdrop} from './backdrop.reducer';
import {admin} from './admin.reducer';
import {doctor} from './doctor.reducer';
import {patient} from './patient.reducer';
import {appointment} from './appointment.reducer';
import {dynamicform} from './dynamicform.reducer';
import {document} from './document.reducer';


const combineReducer = combineReducers({
  authentication,
  registration,
  users,
  alert,
  backdrop,
  admin,
  doctor,
  patient,
  appointment,
  dynamicform,
  document
});


const rootReducer = (state, action) => {
  if (action.type === 'USERS_LOGOUT') {
    return {"authentication":{"loggedIn":false,"user":{},"isEmailValidated":false,"secretQuestion":[],"mobileNo":"","isSecretQuesValidated":false,"isPasswordUpdated":false},"registration":{},"users":{"adminList":[],"isEmailValidated":false,"emailValidationFailiureCount":0},"alert":{"show":false},"backdrop":{"show":false},"admin":{"adminList":[],"profile":{},"secretQuestion":[],"secretQuestionUpdated":false},"doctor":{"allDoctorList":[],"profile":{},"searchResult":[],"appointmentList":[]},"patient":{"all":[],"patientDetailsById":{},"searchResult":[],"appointmentList":[],"registeredSuccessfully":false,"updatedSuccessfully":false},"appointment":{"appointmentList":[],"appointmentInfo":{},"isAppointmentUpdated":false,"errorDescription":""}};
  }
  return combineReducer(state, action);
}
export default rootReducer;